module.exports = __webpack_public_path__ + "img/touziguanli1.26b49b8e.png";